export default function SEButton({ title, children, className = '', noUnderline = false, ...props }) {
    return <div
        className={"flex justify-between items-center pb-4" + (noUnderline ? '' : ' border-b border-gray-200 dark:border-gray-700') + " " + className}
        {...props}
    >
        <h1 className="text-3xl font-bold text-slate-600 tracking-tight m-0">{title}</h1>
        {children && <div>{children}</div>}
    </div>
}